import { FC } from 'react';
import { Box, IconButton, Modal } from '@mui/material';
import { CloseIcon } from '@sweatpals/react-ui-kit';
import { observer } from 'mobx-react-lite';
import Logo from '@/modules/_core/components/logo/logo.component';
import { Order, OrderProps } from './order.component';

export interface OrderModalProps extends OrderProps {
	open: boolean;
	onClose(): void;
}

export const OrderModal: FC<OrderModalProps> = observer(({ open, onClose, ...orderProps }) => (
	<Modal open={open}>
		<Order
			{...orderProps}
			Header={() => (
				<Box display="flex" justifyContent="space-between" alignItems="center">
					<Logo type="light" sx={{ cursor: 'default', height: '21px' }} layout="fill" />
					<IconButton
						sx={{
							color: '#FFFFFF',
							border: '1px solid #FFFFFF66',
							width: '48px',
							height: '48px',
						}}
						onClick={onClose}
					>
						<CloseIcon />
					</IconButton>
				</Box>
			)}
		/>
	</Modal>
));
